import React from 'react';
import twConfig from '@gik/core/tailwind.config';
import { useWindowSize } from 'react-use';

// intentionally manual mapping from tailwind.config with breakpoints we want available to use with the hook
export enum Breakpoint {
  XS_DOWN = 'xs-down',
  XS = 'xs',
  SM_DOWN = 'sm-down',
  SM = 'sm',
  MD_DOWN = 'md-down',
  MD = 'md',
  LG_DOWN = 'lg-down',
  LG = 'lg',
  XL_DOWN = 'xl-down',
  XL = 'xl',
}

export interface ISpecificBreakpointDefinition {
  max?: string;
  min?: string;
}

export type IShorthandBreakpointDefinition = string;

export type BreakpointDefinition = ISpecificBreakpointDefinition | IShorthandBreakpointDefinition;

export function getBreakpointDefinition(twBreakpointDefinition: BreakpointDefinition): ISpecificBreakpointDefinition {
  if (typeof twBreakpointDefinition === 'string') {
    return {
      min: twBreakpointDefinition,
    };
  } else {
    return twBreakpointDefinition;
  }
}

export function calculateBreakpointActive(breakpointDefinition: ISpecificBreakpointDefinition, width: number): boolean {
  if (breakpointDefinition.min !== undefined) {
    return width > Number.parseInt(breakpointDefinition.min);
  } else {
    return width <= Number.parseInt(breakpointDefinition.max);
  }
}

export function useBreakpoint(breakpoint: Breakpoint) {
  const breakpointDefinition: ISpecificBreakpointDefinition = getBreakpointDefinition(
    twConfig.theme.screens[breakpoint]
  );

  const { width } = useWindowSize();
  const [isBreakpointActive, setBreakpointActive] = React.useState<boolean>(
    calculateBreakpointActive(breakpointDefinition, width)
  );

  React.useEffect(() => setBreakpointActive(calculateBreakpointActive(breakpointDefinition, width)), [
    breakpointDefinition,
    width,
  ]);

  return isBreakpointActive;
}
